"use strict";
/**
 * @fileoverview Request body type for adding a new user
 */
Object.defineProperty(exports, "__esModule", { value: true });
